
import { defineComponent, useMeta } from '@nuxtjs/composition-api';
const __sfc_main = defineComponent({
  head: {}
});
__sfc_main.setup = (__props, __ctx) => {
  useMeta(() => ({
    title: 'О магазине'
  }));
  return {};
};
export default __sfc_main;
